import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>AвтоГід</h3>
          <p>Довідник по сучасних автомобілях.<br />Інформація, порівняння, допомога у виборі.</p>
        </div>
        <div className="footer-section">
          <h4>Навігація</h4>
          <ul>
            <li><a href="/">Головна</a></li>
            <li><a href="/catalog">Каталог</a></li>
            <li><a href="/about">Про проєкт</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Контакти</h4>
          <p>Email: support@autogid.ua</p>
          <p>Тел: +380 (99) 123-45-67</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} AвтоГід. Усі права захищені.</p>
      </div>
    </footer>
  );
};

export default Footer;
